export const TEXT_COLOR_LIGHT = "#2D64BC";
export const TEXT_COLOR_DARK = "purple.500";

export const baseFilterValues = {
  followers: ["", ""],
  engagementCount: ["", ""]
}